export class State {
  content: any = null;
  status = false;
}
